import { render, staticRenderFns } from "./ConfigScanEntireTimeframe.vue?vue&type=template&id=12f8e87b&"
import script from "./ConfigScanEntireTimeframe.vue?vue&type=script&lang=js&"
export * from "./ConfigScanEntireTimeframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports